import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { RoutingService } from '@r1-compass-library/services';
import { TitledContainerComponent } from '@r1-compass-library/components/titled-container/titled-container.component';

@Component({
    selector: 'r1-compass-app-admin-settings',
    imports: [RouterModule, TitledContainerComponent, AsyncPipe],
    template: `
        <r1-compass-lib-titled-container [title]="(containerTitle$ | async)!">
            <router-outlet />
        </r1-compass-lib-titled-container>
    `,
})
export class AdminSettingsComponent {
    protected readonly routingService = inject(RoutingService);
    readonly #route = inject(ActivatedRoute);

    containerTitle$: Observable<string> = this.routingService.getContainerTitle(this.#route.data, 'Admin Settings');
}
